module.exports = __webpack_public_path__ + "img/company_logo.b52bdf53.png";